<template>
	<div>
		<svg :width="size" :height="size" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="40" rx="8" fill="#002855"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M20 20.6863C24.3697 20.6863 27.9121 17.1748 27.9121 12.8431C27.9121 8.51149 24.3697 5 20 5C15.6303 5 12.0879 8.51149 12.0879 12.8431C12.0879 17.1748 15.6303 20.6863 20 20.6863ZM20.0003 19.019C23.4415 19.019 26.2311 16.2537 26.2311 12.8425C26.2311 9.43132 23.4415 6.66602 20.0003 6.66602C16.5591 6.66602 13.7695 9.43132 13.7695 12.8425C13.7695 16.2537 16.5591 19.019 20.0003 19.019Z" fill="white"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M20 34.9997C24.3697 34.9997 27.9121 31.4883 27.9121 27.1566C27.9121 22.825 24.3697 19.3135 20 19.3135C15.6303 19.3135 12.0879 22.825 12.0879 27.1566C12.0879 31.4883 15.6303 34.9997 20 34.9997ZM20.0003 33.3334C23.4415 33.3334 26.2311 30.5681 26.2311 27.1569C26.2311 23.7458 23.4415 20.9805 20.0003 20.9805C16.5591 20.9805 13.7695 23.7458 13.7695 27.1569C13.7695 30.5681 16.5591 33.3334 20.0003 33.3334Z" fill="white"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9121 27.8435C17.2818 27.8435 20.8242 24.332 20.8242 20.0004C20.8242 15.6687 17.2818 12.1572 12.9121 12.1572C8.54236 12.1572 5 15.6687 5 20.0004C5 24.332 8.54236 27.8435 12.9121 27.8435ZM12.9124 26.1772C16.3536 26.1772 19.1432 23.4119 19.1432 20.0007C19.1432 16.5895 16.3536 13.8242 12.9124 13.8242C9.47125 13.8242 6.68164 16.5895 6.68164 20.0007C6.68164 23.4119 9.47125 26.1772 12.9124 26.1772Z" fill="white"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M27.0879 27.8435C31.4576 27.8435 35 24.332 35 20.0004C35 15.6687 31.4576 12.1572 27.0879 12.1572C22.7181 12.1572 19.1758 15.6687 19.1758 20.0004C19.1758 24.332 22.7181 27.8435 27.0879 27.8435ZM27.0882 26.1772C30.5294 26.1772 33.319 23.4119 33.319 20.0007C33.319 16.5895 30.5294 13.8242 27.0882 13.8242C23.647 13.8242 20.8574 16.5895 20.8574 20.0007C20.8574 23.4119 23.647 26.1772 27.0882 26.1772Z" fill="white"/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgClowderTitleLogo',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped></style>